/**
 * Utilities for posting messages to the LMS host when the companion is
 * embedded inside an iframe on learn-music.nathanielschool.com.
 *
 * The LMS origin-gates every message it receives, so we can safely post to
 * '*' here — the security check lives on the host side.
 *
 * Standalone usage (not in an iframe) is a no-op: the isEmbedded guard
 * short-circuits before any postMessage call is made.
 */

const isEmbedded = typeof window !== "undefined" && window.parent !== window;

export type EmbedMessageType =
  | "companion-modal-open"
  | "companion-modal-close"
  | "companion-resize";

export function notifyHost(type: EmbedMessageType, extra?: Record<string, unknown>) {
  if (!isEmbedded) return;
  window.parent.postMessage({ type, ...extra }, "*");
}
